export enum SRRStatus {
  New = 1,
  Completed = 2,
  Updated = 3,
}

export function formatSRRStatus(status: SRRStatus) {
  switch (status) {
    case SRRStatus.New:
      return 'New'
    case SRRStatus.Completed:
      return 'Completed'
    case SRRStatus.Updated:
      return 'Updated'
  }
}


// [
//   { "id": 1, "description": "New" },
//   { "id": 2, "description": "Completed" },
//   { "id": 3, "description": "Updated" }
// ]
